import { Component, Input } from '@angular/core';

@Component({
    selector: 'ms-my-bets-taxinfo',
    templateUrl: './my-bets-taxinfo.component.html',
})
export class MyBetsTaxinfoComponent {
    @Input() grossAmount: string;
    @Input() netAmount: string;
    @Input() tax: string;
    @Input() grossTitle: string;
    @Input() netTitle: string;
    @Input() taxTitle: string;
    constructor() {}
}
